
import Search from '~/components/Search/index.vue'
import {
  buildPageHead,
  buildAnalyticsMeta,
  buildHeadScripts,
} from '@/helpers/pageSeo'

export default {
  components: { Search },
  middleware: ['returnUrl', 'onlyRedirectProject'],
  head() {
    const pageTitle = `(${this.results.length}) ${this.$custom$t('resultOfSearch')}:${this.q} | ${this.$store.state.settings.title}`
    const desc = `${this.$custom$t('seo.pages.search.description')} «${this.q}»`
    const { title, meta, link } = buildPageHead(this, {
      title: pageTitle,
      description: desc,
    })
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title,
      meta: [...meta, ...buildAnalyticsMeta(this)],
      link,
      script: buildHeadScripts(this),
      __dangerouslyDisableSanitizers: ['script'],
    }
  },
  async asyncData({ $api, route, redirect, store }) {
    const query = route.query
    let results = []
    if (query.q) {
      const response = await $api.get(
        `Products?searchKey=${encodeURI(query.q)}&currency=${
          store.getters['user/getUserIP'].currency
        }`
      )
      if (response.message === 'OK') results = response.data.items
    } else redirect('/error')
    return {
      results,
      q: query.q,
    }
  },
}
